import { Button, Flex } from "@/base/components/index";
import { useBreakpoint } from "@/base/utils/index";
import { cx } from "antd-style";
import { ModalFooterActionsProps } from "../types/index";
import { useModalFooterActionsStyles } from "./modal-footer-actions.styles";

export const ModalFooterActions = ({
  onSecondary,
  onPrimary,
  loading = false,
  secondaryText,
  primaryText,
  primaryButtonProps = {},
  secondaryButtonProps = {},
  className,
  ...flexProps
}: ModalFooterActionsProps) => {
  const { styles } = useModalFooterActionsStyles();
  const screens = useBreakpoint();

  return (
    <Flex
      gap={12}
      vertical={!screens.md}
      justify="space-between"
      className={cx(styles.root, className)}
      {...flexProps}
    >
      {secondaryText && (
        <Button
          size="large"
          block={!screens.md}
          onClick={onSecondary}
          {...secondaryButtonProps}
        >
          {secondaryText}
        </Button>
      )}
      <Button
        size="large"
        block={!screens.md}
        type="primary"
        loading={loading}
        onClick={onPrimary}
        {...primaryButtonProps}
      >
        {primaryText}
      </Button>
    </Flex>
  );
};
